export const FETCH_CURRENCY_SUCEESS = "FETCH_CURRENCY_START";
export const FETCH_CURRENCY_FAIL = "FETCH_CURRENCY_FAIL";
export const FETCH_RATES_SUCEESS = "FETCH_RATES_START";
export const FETCH_RATES_FAIL = "FETCH_RATES_FAIL";
